import * as React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { selectIsPrivilegedUser } from '@gandi/authentication';
import { selectFromConfig } from '@gandi/redux-config';
import { useTranslator } from '@gandi/translate';
import { Base, PopoverIcon } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "popoverIcon": "ItemPopover-popoverIcon_1lUtS"
};
const decoratePopoverIcon = popoverIcon => /*#__PURE__*/_jsx(Base, {
  children: popoverIcon
});
const moreThan1YearDuration = ({
  duration,
  duration_unit: durationUnit
}) => !!duration && (durationUnit === 'y' && duration > 1 || durationUnit === 'm' && duration > 12);
const selectShowCertSubscriptionFlag = selectFromConfig('flags.SHOW_CERTIFICATE_SUBSCRIPTION', false);
// $FlowFixMe[underconstrained-implicit-instantiation]
const selectShowWarning = createSelector([selectShowCertSubscriptionFlag, selectIsPrivilegedUser], (flag, isPrivileged) => flag || isPrivileged);
export default function ItemPopover({
  item
}) {
  const {
    __
  } = useTranslator();
  const showSSLWarning = useSelector(selectShowWarning);
  if (showSSLWarning && item.product_type === 'certificates') {
    return moreThan1YearDuration(item) && decoratePopoverIcon( /*#__PURE__*/_jsxs(PopoverIcon, {
      className: styles.popoverIcon,
      icon: "infoWire",
      id: `popover-info-ssl-${item.product_type}`,
      behaviour: "click",
      children: [__('For safety reasons, multi-years certificates need to be reissued each year.'), ' ', /*#__PURE__*/_jsx("a", {
        href: __('https://docs.gandi.net/en/ssl/description/multi_year.html'),
        target: "_blank",
        rel: "noopener",
        children: __('How does it work?')
      })]
    }));
  }
  if (item.product_type === 'phone_advisory') {
    return decoratePopoverIcon( /*#__PURE__*/_jsx(PopoverIcon, {
      className: styles.popoverIcon,
      icon: "infoWire",
      id: `popover-info-${item.product_type}`,
      behaviour: "click",
      children: __('Check your emails, you will receive more information on what will happen next.')
    }));
  }
  return null;
}